import type { TaskLog } from "@/contracts/tasks";

// The writer flushes every five seconds; overlap polls to include delayed batches.
export const TASK_LOG_SETTLE_TIME = 10_000;

export function taskLogFromDate(logs: readonly TaskLog[]): number | undefined {
  if (!logs.length) return undefined;
  return logs.reduce((latest, log) => Math.max(latest, log.timestamp), -Infinity)
    - TASK_LOG_SETTLE_TIME / 1000;
}

export function mergeTaskLogs(previous: readonly TaskLog[], incoming: readonly TaskLog[]): TaskLog[] {
  if (incoming.length && previous[0]?.executionId !== incoming[0].executionId) {
    return incoming.toSorted((a, b) => a.timestamp - b.timestamp);
  }

  const merged = new Map(previous.map((log) => [log.id, log]));
  for (const log of incoming) merged.set(log.id, log);
  return [...merged.values()].sort((a, b) => a.timestamp - b.timestamp);
}
